require([ "dijit/Dialog" ], function(Dialog) {
	window.waitingWindow = function (txtContent) {
		var dialog = new Dialog({
			title : "",
			content : "<div id=\"ajax-indicator\"><span>Bitte warten<br/>" + txtContent + "</span></div>",
			style : "width: 0; height: 0; border: 0;"
		});
		dialog.closeButtonNode.style.display = 'none';
		dialog.titleBar.style.display = 'none';
		dialog.autofocus = false;
		dialog.startup();
		dialog.show();
		return dialog;
	}
});
